/**
 * Three-dot "Coach is thinking" indicator. Reduced-motion collapses
 * to a static "…" string so we keep semantic continuity for
 * screen readers and users with vestibular disorders.
 */

import { useTranslation } from 'react-i18next';

import { useReducedMotion } from '@/hooks/useReducedMotion';

export function TypingIndicator() {
  const { t } = useTranslation('coach');
  const reduced = useReducedMotion();

  if (reduced) {
    return (
      <span
        role="status"
        aria-label={t('chat.thinking')}
        className="font-mono text-sm text-ink-muted"
      >
        …
      </span>
    );
  }

  return (
    <span
      role="status"
      aria-label={t('chat.thinking')}
      className="inline-flex items-end gap-1 py-1"
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="inline-block h-1.5 w-1.5 animate-[coach-dot_1s_ease-in-out_infinite] rounded-full bg-ink-muted"
          style={{ animationDelay: `${i * 140}ms` }}
        />
      ))}
      <style>{`
        @keyframes coach-dot {
          0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
          40% { opacity: 1; transform: translateY(-3px); }
        }
      `}</style>
    </span>
  );
}
